import { useState, useEffect } from "react";
import { Plus, Pencil, LayoutTemplate } from "lucide-react";
import { money } from "@/lib/landingSim";
import api from "@/lib/api";
import { TemplateForm } from "@/components/admin/TemplateForm";
import { ConfirmDelete } from "@/components/admin/ConfirmDelete";

export const ProposalTemplatesTab = () => {
  const [list, setList] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/api/webadvisor/templates").then(r => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const done = () => { setEditing(null); load(); };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4" data-testid="templates-tab">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-slate-900 flex items-center gap-2"><LayoutTemplate className="w-5 h-5 text-blue-600" />Proposal templates</h2>
          <p className="text-xs text-slate-500">Save a favourite price, landing pages, deposit and terms. Apply one on any customer's page to fill everything in and write the contract.</p>
        </div>
        {editing === null && <button onClick={() => setEditing({})} className="inline-flex items-center gap-1 bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold px-4 py-2 rounded-lg" data-testid="template-new-btn"><Plus className="w-4 h-4" />New template</button>}
      </div>
      {editing !== null && <TemplateForm key={editing.id || "new"} initial={editing.id ? editing : null} onSaved={done} onCancel={() => setEditing(null)} />}
      {list.length === 0 ? <p className="text-sm text-slate-400 text-center py-6" data-testid="templates-empty">No templates yet. Create one here, or use "Save as template" on any customer's proposal.</p> : (
        <div className="divide-y divide-slate-100">{list.map(t => (
          <div key={t.id} className="flex flex-wrap items-center gap-3 py-3" data-testid={`template-row-${t.id}`}>
            <div className="flex-1 min-w-[200px]">
              <p className="font-semibold text-slate-900">{t.name}</p>
              <p className="text-xs text-slate-500">Price {money(t.project_fee || 0)}{t.package ? ` · ${t.package.page_count} pages (${t.package.price_tier}) ${money(t.landing_total)}` : " · no landing pages"} · {t.deposit_pct >= 100 ? "paid upfront" : `${t.deposit_pct}% deposit`}{t.terms?.length ? ` · ${t.terms.length} term${t.terms.length === 1 ? "" : "s"}` : ""}</p>
            </div>
            <p className="text-sm font-bold text-slate-900" data-testid={`template-total-${t.id}`}>{money(t.estimated_total)}</p>
            <button onClick={() => setEditing(t)} className="p-1.5 rounded text-slate-500 hover:bg-slate-100" title="Edit" data-testid={`template-edit-${t.id}`}><Pencil className="w-3.5 h-3.5" /></button>
            <ConfirmDelete url={`/api/webadvisor/templates/${t.id}`} title={`Delete “${t.name}”?`} description="Proposals already made from it are not changed." onDone={load} testId={`template-delete-${t.id}`} />
          </div>
        ))}</div>
      )}
    </div>
  );
};
